import { Box } from "@dxp-feed/ui/Box"

const SpaceBar = ()=>{
return(<Box as="div" className="mt-6 2md:mt-12"></Box>)
}
export default SpaceBar;